module.exports = __webpack_public_path__ + "img/bg2.868479f3.jpg";